module.exports = __webpack_public_path__ + "public/Icons/childIcon.svg?6cd3bd87";